<template>
  <div class="milestone-card" :class="[cssType, statusClass, locale, { many: props.item.props.length > 3 }]">
    <div class="prop-icons" :class="{ many: props.item.props.length > 3 }">
      <div
        class="prop-icon"
        v-for="(prop, idx) in props.item.props"
        :key="idx"
        :class="{ 'is-locked': props.item.status === 0 }"
      >
        <img
          v-if="!iconErrorMap[idx]"
          :src="getPropIcon(prop.propId)"
          :alt="prop.propId"
          @error="iconErrorMap[idx] = true"
        />
        <span v-else class="icon-fallback">{{ getPropName(t, prop).slice(0, 1) }}</span>
      </div>
    </div>
    <div class="prop-lines">
      <div class="prop-line" v-for="(prop, idx) in props.item.props" :key="idx">
        {{ getPropName(t, prop) }}*{{ prop.propCount }}
      </div>
    </div>
    <div
      class="claim-btn"
      :class="{ claimable: props.item.status === 1 && props.activityPhase === 'active', disabled: props.item.status !== 1 || props.activityPhase !== 'active' }"
      @click="handleClick"
    >{{ statusText }}</div>
  </div>
</template>

<script setup>
import { computed, reactive, defineProps, defineEmits } from 'vue'
import { useI18n } from 'vue-i18n'
import { isMobile } from '@/utils'
import { getPropIcon, getPropName } from '../../../../utils/prop'

const props = defineProps({
  activityPhase: { type: String, default: 'loading' },
  // { rewardCode, targetSpent, props: [{ propId, propName, propCount }], status }
  // status: 0-未达成 1-可领取 2-已领取
  item: {
    type: Object,
    required: true,
  },
})

const emit = defineEmits(['claim'])

const { t, locale } = useI18n()
const cssType = isMobile ? 'mobile' : 'pc'

const iconErrorMap = reactive({})

// 设计稿：已领取=蓝卡、可领取=橙卡、未达成=灰卡
const statusClass = computed(() => {
  if (props.item.status === 2) return 'is-done'
  if (props.item.status === 1) return 'is-ready'
  return 'is-locked'
})

const statusText = computed(() => {
  if (props.item.status === 2) return t('novShopping.milestone.obtained')
  if (props.item.status === 1 && props.activityPhase !== 'active') return t(props.activityPhase === 'not-start' ? 'novShopping.status.notStart' : 'novShopping.status.ended')
  if (props.item.status === 1) return t('novShopping.milestone.claimable')
  return t('novShopping.milestone.notAchieved')
})

const handleClick = () => {
  if (props.activityPhase !== 'active' || props.item.status !== 1) return
  emit('claim')
}
</script>

<style lang="less" scoped src="./pc_style.less"></style>
<style lang="less" scoped src="./mobile_style.less"></style>
